import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
  standalone: true,
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})

export class PageNotFoundComponent implements OnInit, OnDestroy {
  selectedSubscriptionID: number;
  availableSubscriptions: string;

  constructor(private router: Router, private route: ActivatedRoute, private logger: LoggingMessageService, private sessionService: SessionStorageService, private subscriptionService: SubscriptionChangeService) { }

  ngOnInit() {
    const s = this.route.snapshot.toString();
    const state = this.router.routerState;

    this.selectedSubscriptionID =  this.subscriptionService.SelectedSubscription;
    this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    this.logger.info('page-not-found.component', 'ngOnInit', this.selectedSubscriptionID, this.availableSubscriptions, `Navigation page not found. Snapshot: ${s}`, '');
  }

  ngOnDestroy() {
  }

}
